import {
    AppShell,
    Button,
    Card,
    createTheme,
    Input,
    NavLink,
    Paper,
    rem,
} from '@mantine/core';

const pangolinOrange = [
    '#FFF4ED',
    '#FFE4D4',
    '#FFC9A8',
    '#FFA96E',
    '#F08844',
    '#E07B39',
    '#C8652A',
    '#A65222',
    '#85421E',
    '#6D361A',
] as const;

const pangolinDark = [
    '#EDEDEF',
    '#CFCFD4',
    '#B0B0B8',
    '#7E7E88',
    '#52525B',
    '#3F3F46',
    '#27272A',
    '#141415',
    '#0C0C0D',
    '#0C0C0D',
] as const;

const pangolinGray = [
    '#FAFAFA',
    '#F4F4F5',
    '#EAEAEA',
    '#D4D4D8',
    '#A1A1AA',
    '#71717A',
    '#52525B',
    '#3F3F46',
    '#27272A',
    '#18181B',
] as const;

export const pangolinTheme = createTheme({
    primaryColor: 'orange',
    primaryShade: { light: 5, dark: 5 },
    defaultRadius: 'md',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    headings: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
        fontWeight: '600',
    },
    colors: {
        orange: [...pangolinOrange],
        dark: [...pangolinDark],
        gray: [...pangolinGray],
    },
    white: '#FFFFFF',
    black: '#0C0C0D',
    components: {
        AppShell: AppShell.extend({
            styles: {
                navbar: {
                    backgroundColor: 'var(--pkc-sidebar)',
                    borderRight: '1px solid var(--pkc-border)',
                },
                header: {
                    backgroundColor: 'var(--pkc-background)',
                    borderBottom: '1px solid var(--pkc-border)',
                },
                main: {
                    backgroundColor: 'var(--pkc-background)',
                },
            },
        }),
        Button: Button.extend({
            defaultProps: {
                radius: 'md',
            },
        }),
        Paper: Paper.extend({
            defaultProps: {
                radius: 'md',
                withBorder: true,
            },
        }),
        Card: Card.extend({
            defaultProps: {
                radius: 'md',
                withBorder: true,
            },
        }),
        Input: Input.extend({
            defaultProps: {
                radius: 'md',
            },
            styles: {
                input: {
                    borderColor: 'var(--pkc-border)',
                },
            },
        }),
        NavLink: NavLink.extend({
            styles: (theme) => ({
                root: {
                    borderRadius: theme.radius.md,
                    marginBottom: rem(2),
                    '&[data-active]': {
                        backgroundColor: 'var(--pkc-sidebar-accent)',
                    },
                },
                label: {
                    fontWeight: 500,
                },
            }),
        }),
    },
});

export const PANGOLIN_PRIMARY = pangolinOrange[5];
